

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Purpose } from '../models/purpose';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class PurposeService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'purpose/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllPurpose(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllPurpose?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewPurpose(Purpose_Id?: string): Observable<Array<Purpose>> {
      return this.httpService.get(this.apiEndpoint + '/viewPurpose/' + (Purpose_Id ? Purpose_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    savePurpose(Purpose: Purpose): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/savePurpose/', Purpose).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deletePurpose(Purpose_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deletePurpose/' + (Purpose_Id ? Purpose_Id : '00000000-0000-0000-0000-000000000000'), Purpose_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(PurposeCode?:string,Purpose_Id?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?PurposeCode=' + (PurposeCode ? PurposeCode : '')+ '&PurposeId=' + (Purpose_Id ? Purpose_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

